import { ApolloError } from 'apollo-client';
import { AmberHoc, AmberHocProps } from '../../../util';
import {
  GrainBinAccountLinkInternalFragmentFragment as Result,
  withGetAccountGrainBins as HOC,
} from '../__generated';

export type WithGetAccountGrainBinsHocOwnProps = {
  account_id: number;
  loading?: boolean;
  onError?: (error: ApolloError) => void;
};
export type WithGetAccountGrainBinsHocChildProps = {
  loading: boolean;
  grain_bin_links: Result[];
  refetchGrainBinAccountLinks: () => Promise<any>;
};

export const withGetAccountGrainBinsHoc: AmberHoc<
  WithGetAccountGrainBinsHocOwnProps,
  WithGetAccountGrainBinsHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<
      WithGetAccountGrainBinsHocOwnProps,
      WithGetAccountGrainBinsHocChildProps,
      typeof component
    >,
    WithGetAccountGrainBinsHocChildProps
  >({
    options: ({ onError, account_id }) => ({
      onError,
      variables: { account_id },
      errorPolicy: onError ? 'all' : 'none',
    }),
    props: ({ data, ownProps: { loading } }) => {
      if (!data || data.loading || !data.account) {
        return {
          refetchGrainBinAccountLinks: () => Promise.resolve(),
          loading: true,
          grain_bin_links: [],
        };
      }
      return {
        refetchGrainBinAccountLinks: () => data.refetch(),
        loading: loading || false,
        grain_bin_links: data.account.grain_bin_links || [],
      };
    },
  })(component as any);
